import { Link } from "react-scroll";

const quickLinks = [
  { label: "Fleet", to: "services" },
  { label: "Why Us", to: "why-us" },
  { label: "Book a Ride", to: "booking" },
  { label: "Contact", to: "contact" },
];

const socialLinks = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/sagarluxuryride",
    icon: (
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
    ),
  },
  {
    label: "Facebook",
    href: "https://www.facebook.com/people/Sagar-Luxury-Ride/61592204597300",
    icon: (
      <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.891h-2.33v6.987C18.343 21.128 22 16.991 22 12z" />
    ),
  },
  {
    label: "Threads",
    href: "https://www.threads.com/@sagarluxuryride",
    icon: (
      <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.14 3.509 5.498l-2.31.64c-1.05-3.792-3.635-5.73-7.688-5.76-2.923.022-5.16.898-6.664 2.603-1.469 1.667-2.229 4.02-2.256 6.99.027 2.973.787 5.325 2.256 6.992 1.504 1.706 3.741 2.581 6.664 2.603 2.652-.02 4.371-.681 5.759-2.238 1.6-1.795 1.591-3.949 1.235-5.311-.208-.797-.585-1.483-1.113-2.049-.196 1.302-.62 2.35-1.264 3.128-.86 1.037-2.081 1.618-3.629 1.727-1.174.084-2.301-.166-3.174-.706-1.03-.638-1.639-1.618-1.716-2.762-.075-1.117.359-2.163 1.223-2.945.827-.75 1.99-1.194 3.363-1.284 1.06-.069 2.036-.023 2.905.135-.129-.777-.393-1.393-.789-1.837-.539-.605-1.362-.913-2.443-.917-1.678.006-2.788.653-3.396 1.977l-2.108-1.031c.887-1.928 2.652-2.985 5.238-3.008 3.267.03 5.267 1.998 5.628 5.526.216.038.427.081.632.129 2.056.481 3.575 1.687 4.29 3.412.834 2.011.815 4.984-1.454 7.539-1.828 2.057-4.108 2.966-7.383 2.99zm-.19-12.906c-.938.06-1.7.35-2.089.802-.257.296-.402.657-.372 1.075.035.478.32.876.802 1.121.517.264 1.161.373 1.815.309.87-.06 1.469-.31 1.848-.749.28-.324.464-.732.552-1.221-.755-.153-1.664-.234-2.556-.337z" />
    ),
  },
  {
    label: "X",
    href: "https://x.com/sagarluxuryride",
    icon: (
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    ),
  },
  {
    label: "YouTube",
    href: "https://youtube.com/@sagarluxury-b6c",
    icon: (
      <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    ),
  },
];

export default function Footer() {
  return (
    <footer
      className="py-16 border-t border-white/5"
      style={{ background: "#0a0a0a" }}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <img
                src="/saraLuxury.png"
                alt="Sagar Luxury Ride"
                className="h-20 w-auto object-contain"
              />
            </div>
            <p className="text-cream/40 text-sm leading-relaxed mb-4 max-w-xs">
              Premium black car service for discerning clients across the St.
              Louis metro area. Sagar Group LLC.
            </p>
            <p className="text-gold/70 text-xs tracking-widest uppercase font-medium mb-5">
              Available 24/7
            </p>
            <div className="flex items-center gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="flex items-center justify-center w-9 h-9 border border-gold/20 text-cream/55 hover:text-gold hover:border-gold/40 transition-colors duration-300"
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    {social.icon}
                  </svg>
                </a>
              ))}
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-cream/50 text-xs tracking-widest uppercase mb-5 font-medium">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    smooth
                    duration={600}
                    offset={-112}
                    className="text-cream/55 hover:text-gold text-sm cursor-pointer transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact info */}
          <div>
            <h4 className="text-cream/50 text-xs tracking-widest uppercase mb-5 font-medium">
              Contact
            </h4>
            <div className="space-y-3">
              <a
                href="tel:+13146650983"
                className="flex items-center gap-2 text-cream/55 hover:text-gold text-sm transition-colors duration-300"
              >
                <svg className="w-3.5 h-3.5 text-gold/60 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
                (314) 665-0983
              </a>
              <a
                href="mailto:info@sagarluxuryride.com"
                className="flex items-center gap-2 text-cream/55 hover:text-gold text-sm transition-colors duration-300"
              >
                <svg className="w-3.5 h-3.5 text-gold/60 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                info@sagarluxuryride.com
              </a>
              <p className="flex items-center gap-2 text-cream/40 text-sm">
                <svg className="w-3.5 h-3.5 text-gold/60 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                </svg>
                7777 Bonhomme Ave, Suite 1800, Clayton, MO 63105
              </p>
              <p className="flex items-center gap-2 text-cream/40 text-sm">
                <svg className="w-3.5 h-3.5 text-gold/60 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                </svg>
                Available 24/7
              </p>
            </div>
          </div>
        </div>

        <div
          className="pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3"
        >
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4 text-center">
            <p className="text-cream/30 text-xs">
              Licensed &amp; Insured | Clayton, Missouri
            </p>
            <span className="hidden sm:block text-cream/20 text-xs">&middot;</span>
            <p className="text-cream/30 text-xs">
              &copy; 2026 Sagar Group LLC. All rights reserved.
            </p>
          </div>
          <p className="text-cream/25 text-xs">
            Powered by{" "}
            <a
              href="https://nevermissacustomer.ai/"
              className="text-cream/50 hover:text-gold/60 transition-colors duration-300 underline underline-offset-2"
            >
              Never Miss A Customer
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
